// extracted by mini-css-extract-plugin
module.exports = {"infoTable":"styles_infoTable__2g1xM","metric":"styles_metric__LsXVQ","delta":"styles_delta__cDhYg"};